module.exports = __webpack_public_path__ + "img/sub22.6b79e6ad.jpg";